import { HStack, Text, VStack } from '@chakra-ui/react'
import { Format } from '@helo/cms'

import { withUnicodeRouteArrow } from '../../utils/routeLabelDisplay'
import { createWidget } from '../widget-utils'

export type Tag = {
  tagName: string
  tagValue: string
}

export interface TagListWidgetProps {
  tags?: Tag[]
}

export const TagListWidget = ({ tags }: TagListWidgetProps) => {
  return (
    Boolean(tags?.length) && (
      /**
       * TODO: z-index shouldn't need to be added to every widget possibly used in
       * the header container. This needs to be addressed at some point.
       */
      <VStack gap="8px" alignItems="start" mb="24px" zIndex="1">
        {tags?.map(({ tagName, tagValue }, index) => (
          <HStack key={index}>
            <Text color="presets.neutral.80" fontSize="18px" fontWeight="500">
              {tagName}:
            </Text>
            <Text color="presets.neutral.100" fontSize="18px" fontWeight="500">
              {withUnicodeRouteArrow(Format.text({})(tagValue))}
            </Text>
          </HStack>
        ))}
      </VStack>
    )
  )
}

export const TagListWidgetDefinition = createWidget(TagListWidget, {
  type: 'TagList',
})
